import { createAction } from 'redux-actions';

import { actionTypes } from './action-types';

export const appMount = createAction(actionTypes.appMount);

export const executeGA = createAction(actionTypes.executeGA);

export const onlineStatusChange = createAction(actionTypes.onlineStatusChange);
export const serverStatusChange = createAction(actionTypes.serverStatusChange);

// TODO: re-evaluate this since /internal is no longer used.
// `hardGoTo` is used to hit the API server directly
// without going through /internal
// used for things like /signin and /signout
export const hardGoTo = createAction(actionTypes.hardGoTo);

export const submitComplete = createAction(actionTypes.submitComplete);
export const updateComplete = createAction(actionTypes.updateComplete);
export const updateFailed = createAction(actionTypes.updateFailed);

export const saveChallenge = createAction(actionTypes.saveChallenge);
export const saveChallengeComplete = createAction(
  actionTypes.saveChallengeComplete
);

export const acceptTerms = createAction(actionTypes.acceptTerms);
export const acceptTermsComplete = createAction(
  actionTypes.acceptTermsComplete
);
export const acceptTermsError = createAction(actionTypes.acceptTermsError);

export const fetchUser = createAction(actionTypes.fetchUser);
export const fetchUserComplete = createAction(actionTypes.fetchUserComplete);
export const fetchUserError = createAction(actionTypes.fetchUserError);
export const addUserAiAssistantSessions = createAction(
  actionTypes.addUserAiAssistantSessions
);
export const fetchUserSilent = () => ({
  type: actionTypes.fetchUserSilent
});

export const updateAllChallengesInfo = createAction(
  actionTypes.updateAllChallengesInfo
);

export const postCharge = createAction(actionTypes.postCharge);
export const postChargeProcessing = createAction(
  actionTypes.postChargeProcessing
);
export const postChargeComplete = createAction(actionTypes.postChargeComplete);
export const postChargeError = createAction(actionTypes.postChargeError);

export const fetchProfileForUser = createAction(
  actionTypes.fetchProfileForUser
);
export const fetchProfileForUserComplete = createAction(
  actionTypes.fetchProfileForUserComplete
);
export const fetchProfileForUserError = createAction(
  actionTypes.fetchProfileForUserError
);

export const reportUser = createAction(actionTypes.reportUser);
export const reportUserComplete = createAction(actionTypes.reportUserComplete);
export const reportUserError = createAction(actionTypes.reportUserError);

export const resetUserData = createAction(actionTypes.resetUserData);

export const showCert = createAction(actionTypes.showCert);
export const showCertComplete = createAction(actionTypes.showCertComplete);
export const showCertError = createAction(actionTypes.showCertError);

export const updateUserToken = createAction(actionTypes.updateUserToken);
export const deleteUserToken = createAction(actionTypes.deleteUserToken);
export const deleteUserTokenComplete = createAction(
  actionTypes.deleteUserTokenComplete
);

export const hideCodeAlly = createAction(actionTypes.hideCodeAlly);
export const showCodeAlly = createAction(actionTypes.showCodeAlly);
export const tryToShowCodeAlly = createAction(actionTypes.tryToShowCodeAlly);

export const closeSignoutModal = createAction(actionTypes.closeSignoutModal);
export const openSignoutModal = createAction(actionTypes.openSignoutModal);
export const openModalGoToUnlockPage = createAction(
  actionTypes.openModalGoToUnlockPage
);
export const closeModalGoToUnlockPage = createAction(
  actionTypes.closeModalGoToUnlockPage
);

/* Auth */

export const signInLocal = createAction(actionTypes.signInLocal);
export const signUpLocal = createAction(actionTypes.signUpLocal);
export const forgotPassword = createAction(actionTypes.forgotPassword);
export const recoveryPassword = createAction(actionTypes.recoveryPassword);
export const changePassword = createAction(actionTypes.changePassword);
export const createPassword = createAction(actionTypes.createPassword);
export const verificationEmail = createAction(actionTypes.verificationEmail);
export const submitSubscription = createAction(actionTypes.submitSubscription);

/* Ecommerce */

export const verifyPayment = createAction(actionTypes.verifyPayment);
export const updatePaymentUser = createAction(actionTypes.updatePaymentUser);
export const updateAccessUtm = createAction(actionTypes.updateAccessUtm);

export const changeTourStatus = createAction(actionTypes.changeTourStatus);

/* Nacional */

export const completeNacionalRegister = createAction(
  actionTypes.completeNacionalRegister
);

/* Messages */

export const createMessage = createAction(actionTypes.createMessage);
export const updateMessage = createAction(actionTypes.updateMessage);
export const fetchMessages = createAction(actionTypes.fetchMessages);
export const fetchMessagesForAdmin = createAction(
  actionTypes.fetchMessagesForAdmin
);
export const deleteMessage = createAction(actionTypes.deleteMessage);
export const uploadImage = createAction(actionTypes.uploadImage);

/* Inactivity */

export const checkUserInactivityByEmail = createAction(
  actionTypes.checkUserInactivityByEmail
);
export const unlockUserAccount = createAction(actionTypes.unlockUserAccount);

export const startLoading = createAction(actionTypes.startLoading);
export const stopLoading = createAction(actionTypes.stopLoading);

/* Automatic Emails */

export const fetchAutomaticEmails = createAction(
  actionTypes.fetchAutomaticEmails
);
export const fetchAutomaticEmailsComplete = createAction(
  actionTypes.fetchAutomaticEmailsComplete
);
export const fetchAutomaticEmailsError = createAction(
  actionTypes.fetchAutomaticEmailsError
);
export const toggleActiveAutomaticEmail = createAction(
  actionTypes.toggleActiveAutomaticEmail
);
export const editAutomaticEmail = createAction(actionTypes.editAutomaticEmail);

/* Manual Emails */

export const fetchManualEmails = createAction(actionTypes.fetchManualEmails);
export const createManualEmail = createAction(actionTypes.createManualEmail);
export const editManualEmail = createAction(actionTypes.editManualEmail);
export const cancelManualEmail = createAction(actionTypes.cancelManualEmail);

/* Recurring Emails */

export const fetchRecurringEmails = createAction(
  actionTypes.fetchRecurringEmails
);
export const createRecurringEmail = createAction(
  actionTypes.createRecurringEmail
);
export const editRecurringEmail = createAction(actionTypes.editRecurringEmail);
export const toggleActiveRecurringEmail = createAction(
  actionTypes.toggleActiveRecurringEmail
);
export const setLoadingRecurringEmails = createAction(
  actionTypes.setLoadingRecurringEmails
);

/* Emails Drawer */

export const openEmailDrawer = createAction(actionTypes.openEmailDrawer);
export const closeEmailDrawer = createAction(actionTypes.closeEmailDrawer);

/* Quiz */

export const registerQuizUser = createAction(actionTypes.registerQuizUser);
export const updateQuizUserResult = createAction(
  actionTypes.updateQuizUserResult
);
export const toggleReceiveEmails = createAction(
  actionTypes.toggleReceiveEmails
);

export const createNewNationalUser = createAction(
  actionTypes.createNewNationalUser
);

export const createNewUserFromQuiz = createAction(
  actionTypes.createNewUserFromQuiz
);

export const setLoadingChangePassword = createAction(
  actionTypes.setLoadingChangePassword
);

/* Admin Users */

export const fetchAllUsers = createAction(actionTypes.fetchAllUsers);
export const fetchAllPreEnrolled = createAction(
  actionTypes.fetchAllPreEnrolled
);
export const fetchEditUser = createAction(actionTypes.fetchEditUser);

/* Edit User Drawer */

export const openEditUserDrawer = createAction(actionTypes.openEditUserDrawer);
export const closeEditUserDrawer = createAction(
  actionTypes.closeEditUserDrawer
);

export const fetchRequestToDeleteUsers = createAction(
  actionTypes.fetchRequestToDeleteUsers
);
export const fetchRequestToDeleteUsersComplete = createAction(
  actionTypes.fetchRequestToDeleteUsersComplete
);

export const fetchDeletedUsers = createAction(actionTypes.fetchDeletedUsers);
export const fetchDeletedUsersComplete = createAction(
  actionTypes.fetchDeletedUsersComplete
);

export const getCep = createAction(actionTypes.getCep);
export const getCityByState = createAction(actionTypes.getCityByState);

/* Products */
export const fetchProducts = createAction(actionTypes.fetchProducts);

export const setProducts = createAction(actionTypes.setProducts);

export const updateLinkedProduct = createAction(
  actionTypes.updateLinkedProduct
);

export const syncProducts = createAction(actionTypes.syncProducts);

export const setLoadingProducts = createAction(actionTypes.setLoadingProducts);
export const setLoadingSyncProducts = createAction(
  actionTypes.setLoadingSyncProducts
);

/* Unlock module */

export const openUnlockModuleModal = createAction(
  actionTypes.openUnlockModuleModal
);

export const closeUnlockModuleModal = createAction(
  actionTypes.closeUnlockModuleModal
);

export const updateSuperBlockUnlockModuleModal = createAction(
  actionTypes.updateSuperBlockUnlockModuleModal
);

/* Class Groups Admin */
export const fetchAllClassGroups = createAction(
  actionTypes.fetchAllClassGroups
);
export const fetchClassGroupUsers = createAction(
  actionTypes.fetchClassGroupUsers
);
export const newClassGroup = createAction(actionTypes.newClassGroup);
export const editClassGroup = createAction(actionTypes.editClassGroup);
export const removeClassGroup = createAction(actionTypes.removeClassGroup);
export const moveUsersBetweenClassGroups = createAction(
  actionTypes.moveUsersBetweenClassGroups
);

// Teste de nivelamento
export const getPlacementTestQuestions = createAction(
  actionTypes.getPlacementTestQuestions
);

export const postPlacementTestCorrection = createAction(
  actionTypes.postPlacementTestCorrection
);
export const postSendWelcomeMundoTechEmail = createAction(
  actionTypes.postSendWelcomeMundoTechEmail
);

export const fetchWaitingList = createAction(actionTypes.fetchWaitingList);
export const fetchExportWaitingList = createAction(
  actionTypes.fetchExportWaitingList
);
export const fetchReprovedAndDropoutList = createAction(
  actionTypes.fetchReprovedAndDropoutList
);
export const fetchExportReprovedAndDropoutList = createAction(
  actionTypes.fetchExportReprovedAndDropoutList
);
export const fetchConfirmedList = createAction(actionTypes.fetchConfirmedList);
export const fetchExportConfirmedList = createAction(
  actionTypes.fetchExportConfirmedList
);
export const fetchWaitingToConfirmList = createAction(
  actionTypes.fetchWaitingToConfirmList
);
export const fetchExportWaitingToConfirmList = createAction(
  actionTypes.fetchExportWaitingToConfirmList
);
export const fetchAllGroups = createAction(actionTypes.fetchAllGroups);

export const setCurrentTheme = createAction(actionTypes.setCurrentTheme);

// Email Stats Actions
export const fetchEmailStats = createAction(actionTypes.fetchEmailStats);
export const fetchEmailStatsComplete = createAction(
  actionTypes.fetchEmailStatsComplete
);
export const fetchEmailStatsError = createAction(
  actionTypes.fetchEmailStatsError
);

export const fetchEmailSentQuantity = createAction(
  actionTypes.fetchEmailSentQuantity
);
export const fetchEmailSentQuantityComplete = createAction(
  actionTypes.fetchEmailSentQuantityComplete
);
export const fetchEmailSentQuantityError = createAction(
  actionTypes.fetchEmailSentQuantityError
);

export const updateEmailStats = createAction(actionTypes.updateEmailStats);
export const updateEmailStatsComplete = createAction(
  actionTypes.updateEmailStatsComplete
);
export const updateEmailStatsError = createAction(
  actionTypes.updateEmailStatsError
);

/* Email Logs */
export const fetchEmailLogs = createAction(actionTypes.fetchEmailLogs);
export const fetchEmailLogsComplete = createAction(
  actionTypes.fetchEmailLogsComplete
);
export const fetchEmailLogsError = createAction(
  actionTypes.fetchEmailLogsError
);
export const exportEmailLogs = createAction(actionTypes.exportEmailLogs);
export const exportEmailLogsComplete = createAction(
  actionTypes.exportEmailLogsComplete
);
export const exportEmailLogsError = createAction(
  actionTypes.exportEmailLogsError
);

/* FAQ Admin */
export const fetchAllFAQs = createAction(actionTypes.fetchAllFAQs);
export const fetchPublicFAQs = createAction(actionTypes.fetchPublicFAQs);
export const createFAQ = createAction(actionTypes.createFAQ);
export const updateFAQ = createAction(actionTypes.updateFAQ);
export const removeFAQ = createAction(actionTypes.removeFAQ);
export const updateFAQOrder = createAction(actionTypes.updateFAQOrder);

/* Discord */
export const fetchDiscordUser = createAction(actionTypes.fetchDiscordUser);
export const fetchDiscordLogs = createAction(actionTypes.fetchDiscordLogs);
export const fetchDiscordLogHistory = createAction(
  actionTypes.fetchDiscordLogHistory
);
export const exportDiscordLogs = createAction(actionTypes.exportDiscordLogs);
export const fetchDiscordRole = createAction(actionTypes.fetchDiscordRole);

/* Enrollment Management */
export const enrollStudent = createAction(actionTypes.enrollStudent);
export const markDropout = createAction(actionTypes.markDropout);
export const fetchClassGroupsByGroup = createAction(
  actionTypes.fetchClassGroupsByGroup
);
export const fetchEnrollmentAuditLogs = createAction(
  actionTypes.fetchEnrollmentAuditLogs
);
